<template>
  <span class="def-video-wrapper">
    <img
      v-if="!isShow"
      ref="element"
      :src="getBasePreview"
      alt="video"
      class="def-video"
      :width="getVideo.width + 'px'"
      :height="getVideo.height + 'px'"
    />
    <video
      v-else
      ref="video"
      class="def-video"
      v-bind="getVideo"
      :muted="muted"
      loop
      playsinline
      autoplay
    ></video>
  </span>
</template>

<script>
import { screenType } from '@use/useDeviceInfo';

export default {
  name: 'DefVideo',
  props: {
    result: {
      type: Object,
    },
    muted: {
      type: Boolean,
      default: true,
    },
    play: {
      type: Boolean,
      default: true,
    },
    lazyLoad: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      intersectionObserver: null,
      isShow: !this.lazyLoad,
      options: {
        rootMargin: '100px',
        threshold: 0.01,
      },
      screenType,
    };
  },
  computed: {
    getVideo() {
      return this.result?.[this.screenType] || this.result;
    },
    getBasePreview() {
      try {
        const canvas = document.createElement('canvas');
        canvas.width = this.getVideo.width;
        canvas.height = this.getVideo.height;
        return canvas.toDataURL();
      } catch (err) {
        console.error(err);
      }
    },
  },
  watch: {
    play(newValue) {
      if (newValue) {
        const promise = this.$refs?.video?.play();

        // if (promise !== undefined && process.env.NODE_ENV === 'development') {
        //   promise
        //     .catch((error) => {
        //       // Auto-play was prevented
        //       // Show a UI element to let the user manually start playback
        //       alert(error);
        //     })
        //     .then(() => {
        //       // Auto-play started
        //     });
        // }
      } else {
        this.$refs?.video?.pause();
      }
    },
  },
  mounted() {
    try {
      const { element } = this.$refs;
      if (this.result && !this.intersectionObserver && element && this.lazyLoad) {
        if ('IntersectionObserver' in window) {
          this.intersectionObserver = new IntersectionObserver(this.observerCallBack, this.options);
          this.intersectionObserver.observe(element);
        } else {
          this.isShow = true;
        }
      }
    } catch (err) {
      console.error(err);
    }
  },
  beforeUnmount() {
    try {
      if (
        'IntersectionObserver' in window &&
        this.result &&
        this.intersectionObserver &&
        this.lazyLoad
      ) {
        this.intersectionObserver.unobserve(this.$refs.element);
      }
    } catch (err) {
      console.error(err);
    }
  },
  methods: {
    async observerCallBack(entries) {
      try {
        // If intersectionRatio is 0, the target is out of view
        // and we do not need to do anything.
        // console.log(entries[0].intersectionRatio);

        if (entries[0].intersectionRatio <= 0) {
          return;
        }

        this.isShow = true;

        await this.$nextTick();

        // stop video if play false
        if (!this.play) {
          this.$refs?.video?.pause();
        }
      } catch (err) {
        console.error(err);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.def-video-wrapper {
  display: block;
}
.def-video {
  display: block;
  max-width: 100%;
  height: auto;
}
</style>
